import React from 'react';
import s from './s.module.less';
import type { TPreviewQuestion } from 'types/operation';
import { ELayoutType } from 'constants/textVisit';
import cx from 'classnames';

type IProps = {
    isMobileMode: boolean;
    previewItem: TPreviewQuestion;
};

const PreviewQuestion: React.FC<IProps> = (props) => {
    const { isMobileMode, previewItem } = props;

    // 获取布局类型，默认为 default
    const layout = previewItem.layout || ELayoutType.DEFAULT;

    // 根据布局类型返回不同的样式类名
    const getLayoutClassName = () => {
        switch (layout) {
            case ELayoutType.WL_FULL_NOTE_HORIZON_STYLE:
                return s.horizonLayout;
            case ELayoutType.WL_FULL_NOTE:
                return s.fullNoteLayout;
            case ELayoutType.DEFAULT:
            default:
                return s.defaultLayout;
        }
    };

    // 渲染文本内容（带高亮处理）
    const renderTitle = () => {
        const title = previewItem.title || '';
        const processedTitle = title
            .replace(/<b>(.*?)<\/b>/g, '<b>$1</b>')
            .replace(/\[color\](.*?)\[\/color\]/g, '<b>$1</b>');

        return (
            <p
                className={s.title}
                dangerouslySetInnerHTML={{
                    __html: processedTitle,
                }}
            />
        );
    };

    // 渲染图片
    const renderImage = () => {
        // 对于全屏布局，使用PC图片作为背景
        if (layout === ELayoutType.WL_FULL_NOTE) {
            const imgUrl = isMobileMode ? previewItem.mobileImgUrl : previewItem.imgUrl;
            if (!imgUrl) return null;

            return (
                <div
                    className={s.fullScreenImgWrapper}
                    style={{
                        backgroundImage: `url(${imgUrl})`,
                    }}
                />
            );
        }

        // 其他布局使用普通图片显示
        const imgUrl = isMobileMode ? previewItem.mobileImgUrl : previewItem.imgUrl;
        if (!imgUrl) return null;

        return (
            <div className={s.imgWrapper}>
                <img
                    src={imgUrl}
                    alt={previewItem.title}
                    className={s.img}
                />
            </div>
        );
    };

    // 渲染左右布局（标题在左，图片在右）
    const renderHorizonLayout = () => {
        const seq = previewItem.seq || 0;
        return (
            <div className={cx(s.engagementQuestion, s.horizonContent)}>
                <div className={s.count}>
                    Question {seq + 1} of {previewItem.count}
                </div>
                <div className={s.horizonInner}>
                    <div className={s.horizonLeft}>
                        {renderTitle()}
                        <div className={s.cta}>Next</div>
                    </div>
                    <div className={s.horizonRight}>
                        {renderImage()}
                    </div>
                </div>
            </div>
        );
    };

    // 渲染全屏布局
    const renderFullNoteLayout = () => {
        const seq = previewItem.seq || 0;
        return (
            <div className={cx(s.engagementQuestion, s.fullNoteContent)}>
                <div className={s.count}>
                    Question {seq + 1} of {previewItem.count}
                </div>
                {/* 全屏背景图 */}
                {renderImage()}
                {/* 文字内容显示在背景图上 */}
                <div className={s.fullNoteTextContent}>
                    {renderTitle()}
                    <div className={s.cta}>Next</div>
                </div>
            </div>
        );
    };

    // 渲染默认布局（标题在上，图片在下）
    const renderDefaultLayout = () => {
        const seq = previewItem.seq || 0;
        return (
            <div className={cx(s.engagementQuestion, s.defaultContent)}>
                <div className={s.count}>
                    Question {seq + 1} of {previewItem.count}
                </div>
                {renderTitle()}
                {renderImage()}
                <div className={s.cta}>Next</div>
            </div>
        );
    };

    // 根据布局类型渲染对应的内容
    const renderContentByLayout = () => {
        switch (layout) {
            case ELayoutType.WL_FULL_NOTE_HORIZON_STYLE:
                return renderHorizonLayout();
            case ELayoutType.WL_FULL_NOTE:
                return renderFullNoteLayout();
            case ELayoutType.DEFAULT:
            default:
                return renderDefaultLayout();
        }
    };

    return (
        <div className={isMobileMode ? s.previewMobile : s.previewPc}>
            {previewItem.type === 'questionFrom' &&
                previewItem.questionsPreviewLink && (
                <iframe
                    src={previewItem.questionsPreviewLink}
                    title="google form"
                    width="100%"
                    height="440px"
                />
            )}
            {previewItem.type === 'engagementQuestion' && (
                <div className={cx(s.content, getLayoutClassName())}>
                    <div className={s.decoration}>
                        <i />
                        <i />
                        <i />
                        <i />
                    </div>
                    <div className={s.contentInner}>
                        {!!previewItem.engagementQuestionCount &&
                            previewItem.engagementQuestionCount > 0 &&
                            renderContentByLayout()}
                    </div>
                </div>
            )}
        </div>
    );
};

export default PreviewQuestion;
